import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { useTRPC } from '@/trpc'
import { TTasks } from '@/types/trpc.types'
import { useQuery } from '@tanstack/react-query'
import React from 'react'

const TasksDashboard = () => {
  const { trpc } = useTRPC();

  const { data:usersWithTasks } = useQuery({
    queryKey: ['user-tasks'],
    queryFn: async () => {
      const usersWithTasks = await trpc.users.search.query({
        with: {
          tasks: true
        }
      })
      return usersWithTasks
    }
  })

  return (
    <div>
      <div className='bg-foreground/10 rounded-lg p-4 flex flex-col gap-2'>
        <p className='uppercase text-foreground/50 font-medium text-sm'>Open taken</p>
        <div>
          <Table className='overflowclip w-full relative' divClassname='overflow-y-scroll max-h-96'>
            <TableHeader className='sticky top-0 w-full border-b bg-sidebar/50 backdrop-blur-md'>
              <TableRow>
                <TableHead>Scout</TableHead>
                <TableHead>Aantal open</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody >
              {usersWithTasks && usersWithTasks?.users?.map((user,i)=>{ 
                return (
                  <TableRow key={user.id}>
                    <TableCell>{user.first_name} {user.last_name}</TableCell>
                    <TableCell>{'tasks' in user ? (user?.tasks?.length || 0) : 0}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  )
}

export default TasksDashboard